import L from 'leaflet';

const initMap = () => {
  const { feag } = window;
  const maps = document.querySelectorAll('[data-projects-map]');

  if (maps.length) {
    maps.forEach(map => {
      const mapData = JSON.parse(map.dataset.mapInfo);
      const bounds = [];

      const leafletMap = L.map(map.id, {
        scrollWheelZoom: false,
        zoomControl: false,
      });

      leafletMap.touchZoom.disable();
      leafletMap.doubleClickZoom.disable();
      leafletMap.scrollWheelZoom.disable();
      leafletMap.boxZoom.disable();
      leafletMap.keyboard.disable();

      L.control
        .zoom({
          position: 'bottomleft',
        })
        .addTo(leafletMap);

      // eslint-disable-next-line no-unused-vars
      mapData.forEach((item, index) => {
        bounds.push([item.marker.lat, item.marker.lng]);

        const MarkerIcon = L.divIcon({
          className: 'c-map__marker',
          iconSize: [16, 16],
          iconAnchor: [8, 16],
          popupAnchor: [0, 0],
          html: `<div class="c-map__marker-dot"></div>`,
        });

        const popup = L.popup({
          className: `c-map__popup c-map__popup--${item.type}`,
          closeButton: false,
        })
          .setLatLng([item.marker.lat, item.marker.lng])
          .setContent(
            `<p class="c-map__popup-title">${
              item.title
            }</p><p class="c-map__popup-description">${item.description}</p>`,
          );

        const marker = L.marker([item.marker.lat, item.marker.lng], {
          icon: MarkerIcon,
        }).addTo(leafletMap);

        marker.bindPopup(popup).openPopup();
      });

      leafletMap.on('popupopen', e => {
        // eslint-disable-next-line no-underscore-dangle
        e.popup._source._icon.classList.add('c-map__marker--active');
      });

      leafletMap.on('popupclose', e => {
        // eslint-disable-next-line no-underscore-dangle
        e.popup._source._icon.classList.remove('c-map__marker--active');
      });

      leafletMap.fitBounds(bounds);

      leafletMap.attributionControl.setPrefix('');
      L.tileLayer(
        `https://api.mapbox.com/styles/v1/davidus243/cm8y3yier001o01s4hfe46ght/tiles/256/{z}/{x}/{y}?access_token=${
          feag.mapbox.token 
        }`,
        {
          attribution:
            '<a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        },
      ).addTo(leafletMap);
    });
  }
};

initMap();
